import { getVariantFromError } from "@wayflyer/blackbox-fe";
import { isSessionExpiredError } from "@wayflyer/auth-sdk";

import type { ErrorVariant } from "./error-presets";

/**
 * Picks the error-page variant for a caught error. Use this in error boundaries rather than `getVariantFromError`
 * directly.
 *
 * An expired session arrives as an ordinary axios 401/403, so `getVariantFromError` — which reads `response.status`
 * before anything else — would resolve it to the "Access denied" page. That is wrong: the user's role is fine, their
 * session has simply lapsed. Checking for it first is the only reason this wrapper exists.
 */
export const getErrorVariant = (error: unknown): ErrorVariant =>
  isSessionExpiredError(error) ? "session-expired" : getVariantFromError(error);

export class WayflyerError extends Error {
  public name: string;
  public variant: ErrorVariant;
  constructor(message: string, variant: ErrorVariant) {
    super(message);
    this.name = "WayflyerError";
    this.variant = variant;
  }
}
